import HttpService from './HttpService';
import { pollToLiveeFormat, statsToLiveeFormat } from 'polle-shared-formatters';

class PollService extends HttpService {
  getActive() {
    return this.http
      .get('/api/data')
      .then(({ data }) => data)
      .then(({ data: { ActivePoll, PollWithDisplayedStats, Stats } }) => {
        return {
          poll:
            ActivePoll || PollWithDisplayedStats
              ? pollToLiveeFormat(ActivePoll || PollWithDisplayedStats)
              : {},
          stats: Stats ? statsToLiveeFormat(Stats) : {}
        };
      })
      .catch(this.onError);
  }
}

export default new PollService();
